import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import dhofarLogo from '../assets/images/Logo.png';

export default function TopNavbar () {


  return (
    <div className="mb-3">
      <AppBar
        sx={{
          backgroundColor: 'white', // light grey background
          height: '100px',
          boxShadow: 1,
          zIndex: '0',
          position: 'sticky'

        }}
      >
        <Toolbar sx={{ minHeight: '100px', display: 'flex', justifyContent: 'space-between' }}>
          {/* Logo */}
          <Box component='a' href='#' sx={{ display: 'flex', alignItems: 'center', px: 2 }}>
            <div className='container-fluid'>
              <img src={dhofarLogo} alt='Brand logo' style={{ width: '220px' }} />
            </div>
          </Box>
        </Toolbar>
      </AppBar>
    </div>
  );
}
